import {ViewType} from "./box-service";

export class Images {
    private alreadyLoadedImages = 0;
    private imagesLoaded = false;
    private images: {[name: string]: HTMLImageElement} = {};
    private callbacks = [];

    public constructor() {
        const validCombos = this.getValidStdCubeCombinations();

        for (let combo of validCombos) {
            const components = combo.split(':');
            const size = components[0];
            const color = components[1];
            const door = components[2];
            const back = components[3];
            const drawers = components[4];
            const shelf = components[5];

            this.addImage(
              'iso-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf,
              './renders/iso-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf + '.webp');

            this.addImage(
              '2d-' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf,
              './renders/' + size + '_' + color + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf + '.webp');
        }

        const stdCubeCross = this.getValidStdCubeCrossDivider();
        for (let combo of stdCubeCross) {
            const components = combo.split(':');

            const size = components[0];
            const color = components[1];
            const back = components[2];

            this.addImage(
              `iso-${size}_${color}-${back}`,
              `./renders/iso-${size}-${color}-x-${back}.webp`
            );

            this.addImage(
              `2d-${size}_${color}-${back}`,
              `./renders/2d-${size}-${color}-x-${back}.webp` //`./renders/2d-${size}-${color}-x-${back}.webp`
            );
        }

        const cornerCubeCombos = this.getValidCornerCubeCombinations();
        for (let combo of cornerCubeCombos) {
            const components = combo.split(':');
            const size = components[0];
            const color = components[1];
            const direction = components[2];

            this.addImage(
              `iso-${size}_${color}-${direction}`,
              `./renders/iso-${size}_${color}-${direction}.webp`
            );

            this.addImage(
              `2d-${size}_${color}-${direction}`,
              `./renders/2d-${size}_${color}-${direction}.webp`
            );
        }
    }

    public addImagesLoadedListener (cb) {
        this.callbacks.push(cb);

        if (this.areImagesLoaded()) {
            cb();
        }
    }

    public areImagesLoaded() {
        return this.imagesLoaded;
    }

    public getImage(view: ViewType, imageName: string): HTMLImageElement | undefined {
        if (!this.imagesLoaded) {
            return undefined;
        }

        const imagesMaybe = this.images[`${view}-${imageName}`];

        if (imagesMaybe) {
            return imagesMaybe;
        }

        return undefined;
    }

    private getValidStdCubeCombinations() {
        const colors = ['n', 'w'];

        const combos = [];
        for (const color of colors) {
            combos.push(`small:${color}:0:0:000:0000`);
            combos.push(`small:${color}:0:0:000:${color}000`);
            combos.push(`small:${color}:0:0:000:${color}${color}00`);
            combos.push(`small:${color}:0:0:${color}00:${color}000`);
            combos.push(`small:${color}:0:0:0${color}0:0000`);
            combos.push(`small:${color}:0:0:${color}${color}0:0000`);
            combos.push(`small:${color}:0:${color}:000:0000`);
            combos.push(`small:${color}:0:${color}:000:${color}000`);
            combos.push(`small:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`small:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`small:${color}:0:${color}:0${color}0:0000`);
            combos.push(`small:${color}:0:${color}:${color}${color}0:0000`);
            combos.push(`small:${color}:${color}:0:000:0000`);
            combos.push(`small:${color}:${color}:${color}:000:0000`);

            combos.push(`wide:${color}:0:0:000:0000`);
            combos.push(`wide:${color}:0:0:000:${color}000`);
            combos.push(`wide:${color}:0:0:000:${color}${color}00`);
            combos.push(`wide:${color}:0:0:${color}00:${color}000`);
            combos.push(`wide:${color}:0:0:0${color}0:0000`);
            combos.push(`wide:${color}:0:0:${color}${color}0:0000`);
            combos.push(`wide:${color}:0:${color}:000:0000`);
            combos.push(`wide:${color}:0:${color}:000:${color}000`);
            combos.push(`wide:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`wide:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`wide:${color}:0:${color}:0${color}0:0000`);
            combos.push(`wide:${color}:0:${color}:${color}${color}0:0000`);
            combos.push(`wide:${color}:${color}:0:000:0000`);
            combos.push(`wide:${color}:${color}:${color}:000:0000`);

            combos.push(`tall:${color}:0:0:000:0000`);
            combos.push(`tall:${color}:0:0:000:${color}000`);
            combos.push(`tall:${color}:0:0:000:${color}${color}00`);
            combos.push(`tall:${color}:0:0:000:${color}${color}${color}0`);
            combos.push(`tall:${color}:0:0:${color}00:${color}000`);
            combos.push(`tall:${color}:0:0:${color}00:${color}${color}00`);
            combos.push(`tall:${color}:0:0:0${color}0:${color}000`);
            combos.push(`tall:${color}:0:0:00${color}:0000`);
            combos.push(`tall:${color}:0:0:00${color}:${color}000`);
            combos.push(`tall:${color}:0:0:${color}${color}0:${color}000`);
            combos.push(`tall:${color}:0:0:${color}0${color}:${color}000`);
            combos.push(`tall:${color}:0:0:0${color}${color}:0000`);
            combos.push(`tall:${color}:0:0:${color}${color}${color}:0000`);
            combos.push(`tall:${color}:0:${color}:000:0000`);
            combos.push(`tall:${color}:0:${color}:000:${color}000`);
            combos.push(`tall:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`tall:${color}:0:${color}:000:${color}${color}${color}0`);
            combos.push(`tall:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}00:${color}${color}00`);
            combos.push(`tall:${color}:0:${color}:0${color}0:${color}000`);
            combos.push(`tall:${color}:0:${color}:00${color}:0000`);
            combos.push(`tall:${color}:0:${color}:00${color}:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}${color}0:${color}000`);
            combos.push(`tall:${color}:0:${color}:${color}0${color}:${color}000`);
            combos.push(`tall:${color}:0:${color}:0${color}${color}:0000`);
            combos.push(`tall:${color}:0:${color}:${color}${color}${color}:0000`);
            combos.push(`tall:${color}:${color}:0:000:0000`);
            combos.push(`tall:${color}:${color}:${color}:000:0000`);

            combos.push(`large:${color}:0:0:000:0000`);
            combos.push(`large:${color}:0:0:000:${color}000`);
            combos.push(`large:${color}:0:0:000:${color}${color}00`);
            combos.push(`large:${color}:0:0:000:${color}${color}${color}0`);
            combos.push(`large:${color}:0:0:${color}00:${color}000`);
            combos.push(`large:${color}:0:0:${color}00:${color}${color}00`);
            combos.push(`large:${color}:0:0:0${color}0:${color}000`);
            combos.push(`large:${color}:0:0:00${color}:0000`);
            combos.push(`large:${color}:0:0:00${color}:${color}000`);
            combos.push(`large:${color}:0:0:${color}${color}0:${color}000`);
            combos.push(`large:${color}:0:0:${color}0${color}:${color}000`);
            combos.push(`large:${color}:0:0:0${color}${color}:0000`);
            combos.push(`large:${color}:0:0:${color}${color}${color}:0000`);
            combos.push(`large:${color}:0:${color}:000:0000`);
            combos.push(`large:${color}:0:${color}:000:${color}000`);
            combos.push(`large:${color}:0:${color}:000:${color}${color}00`);
            combos.push(`large:${color}:0:${color}:000:${color}${color}${color}0`);
            combos.push(`large:${color}:0:${color}:${color}00:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}00:${color}${color}00`);
            combos.push(`large:${color}:0:${color}:0${color}0:${color}000`);
            combos.push(`large:${color}:0:${color}:00${color}:0000`);
            combos.push(`large:${color}:0:${color}:00${color}:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}${color}0:${color}000`);
            combos.push(`large:${color}:0:${color}:${color}0${color}:${color}000`);
            combos.push(`large:${color}:0:${color}:0${color}${color}:0000`);
            combos.push(`large:${color}:0:${color}:${color}${color}${color}:0000`);
            combos.push(`large:${color}:${color}:0:000:0000`);
            combos.push(`large:${color}:${color}:${color}:000:0000`);
        }

        return combos;
    }

    private getValidStdCubeCrossDivider() {
        const colors = ['n', 'w'];

        const combos = [];
        for (const color of colors) {
            combos.push(`small:${color}:0`);
            combos.push(`small:${color}:${color}`);

            combos.push(`tall:${color}:0`);
            combos.push(`tall:${color}:${color}`);

            combos.push(`wide:${color}:0`);
            combos.push(`wide:${color}:${color}`);

            combos.push(`large:${color}:0`);
            combos.push(`large:${color}:${color}`);
        }

        return combos;
    }

    private getValidCornerCubeCombinations() {
        const colors = ['n', 'w'];

        const combos = [];
        for (const color of colors) {
            combos.push(`small-corner:${color}:r`);
            combos.push(`small-corner:${color}:l`);
            combos.push(`tall-corner:${color}:r`);
            combos.push(`tall-corner:${color}:l`);
        }

        return combos;
    }

    private addImage(name, path) {
        const image = new Image();
        image.src = path;
        image.onload = () => {
            this.alreadyLoadedImages++;

            if (Object.keys(this.images).length === this.alreadyLoadedImages) {
                this.markImagesLoaded();
            }
        };
        image.onerror = () => {
            this.alreadyLoadedImages++;

            if (Object.keys(this.images).length === this.alreadyLoadedImages) {
                this.markImagesLoaded();
            }
        };

        this.images[name] = image;
    };

    private markImagesLoaded () {
        this.imagesLoaded = true;

        for (const cb of this.callbacks) {
            cb();
        }
    };
}
